import React from 'react';
import { Box, Typography, Link } from '@mui/material';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import FacebookIcon from '@mui/icons-material/Facebook';
import InstagramIcon from '@mui/icons-material/Instagram';
import logo from 'assets/hiCellLogo.png'; // ajuste o caminho conforme seu projeto
import EmailIcon from '@mui/icons-material/Email';
import PropTypes from 'prop-types';
import { getWhatsappUrl } from 'utils/whatsappLinkGenerator';

const Footer = ({ menuCategories }) => {
  return (
    <>
      <Box
        component="footer"
        sx={{
          bgcolor: 'black',
          color: 'white',
          px: 4,
          py: 6,
          display: 'flex',
          flexDirection: { xs: 'column', md: 'row' },
          justifyContent: 'space-between',
          alignItems: { xs: 'center', md: 'flex-start' },
          gap: 4,
        }}
      >
        {/* LOGO E FRASE */}
        <Box textAlign={{ xs: 'center' }}>
          <Box component="img" src={logo} alt="HiCell Logo" sx={{ width: 100, mb: 1 }} />
          <Typography color="#92b21f" fontWeight="bold">
            A LOJA 5 ESTRELAS DE CAÇADOR!
          </Typography>
        </Box>

        {/* CATEGORIAS */}
        <Box textAlign={{ xs: 'center', md: 'left' }}>
          <Typography fontWeight="bold" mb={1}>
            CATEGORIAS
          </Typography>
          {menuCategories?.map((item) => (
            <Typography key={crypto.randomUUID()}>
              <Link href={`/products?categoryId=${item.id}`} underline="none" color="inherit">
                {item.name}
              </Link>
            </Typography>
          ))}
        </Box>

        {/* REDES SOCIAIS + CONTATO */}
        <Box textAlign={{ xs: 'center', md: 'left' }}>
          <Typography fontWeight="bold" mb={1} color="#92b21f">
            SIGA-NOS NAS REDES SOCIAIS
          </Typography>
          <Box
            display="flex"
            alignItems="center"
            gap={1}
            mb={1}
            component={Link}
            href="https://www.instagram.com/lojahicell/"
            target="_blank"
            underline="hover"
            color="inherit"
          >
            <InstagramIcon color="secondary" />
            <Typography>Instagram</Typography>
          </Box>
          <Box
            display="flex"
            alignItems="center"
            gap={1}
            mb={2}
            component={Link}
            href="https://www.facebook.com/hunterimportados/"
            target="_blank"
            underline="hover"
            color="inherit"
          >
            <FacebookIcon color="primary" />
            <Typography>Facebook</Typography>
          </Box>

          <Typography fontWeight="bold" color="#92b21f" mb={1}>
            CONTATO
          </Typography>
          <Box display="flex" alignItems="center" gap={1}>
            <WhatsAppIcon sx={{ color: '#92b21f' }} />
            <Typography>49 8425-6512</Typography>
          </Box>
          <Box display="flex" alignItems="center" gap={1}>
            <EmailIcon sx={{ color: '#92b21f' }} />
            <Link href="mailto:lojahicell@gmail.com" underline="hover" color="inherit">
              lojahicell@gmail.com
            </Link>
          </Box>
        </Box>
      </Box>

      {/* RODAPÉ FINAL */}
      <Box textAlign="center" bgcolor="black" color="white" py={2} fontSize="12px">
        <Typography>Rua Dr. Altamiro Guimarães, 25, Sala 2 - Centro - Caçador - SC</Typography>
        <Typography>© 2025 Hi Cell Ltda CNPJ: 43.401.961/0001-10</Typography>
      </Box>

      {/* BOTÃO FLUTUANTE WHATSAPP */}
      <Box
        sx={{
          position: 'fixed',
          bottom: 16,
          right: 16,
          zIndex: 9999,
          backgroundColor: '#92b21f',
          borderRadius: '50%',
          width: 56,
          height: 56,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          boxShadow: '0 0 12px rgba(0,0,0,0.4)',
          cursor: 'pointer',
        }}
      >
        <WhatsAppIcon
          sx={{ color: 'white' }}
          onClick={() => window.open(getWhatsappUrl(), '_blank')}
        />
      </Box>
    </>
  );
};
Footer.propTypes = {
  menuCategories: PropTypes.arrayOf(PropTypes.string).isRequired,
};

export default Footer;
